var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadClosure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_14228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9902 1.93007C5.95277 1.93007 1.86913 6.21789 1.86913 11.5072C1.86913 16.7965 5.95277 21.0843 10.9902 21.0843C16.0276 21.0843 20.1113 16.7965 20.1113 11.5072C20.1113 6.21789 16.0276 1.93007 10.9902 1.93007ZM0.0449219 11.5072C0.0449219 5.16003 4.94529 0.0146484 10.9902 0.0146484C17.0351 0.0146484 21.9355 5.16003 21.9355 11.5072C21.9355 17.8543 17.0351 22.9997 10.9902 22.9997C4.94529 22.9997 0.0449219 17.8543 0.0449219 11.5072Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60547 9.5915C4.60547 9.06257 5.01383 8.63379 5.51757 8.63379H16.4628C16.9666 8.63379 17.375 9.06257 17.375 9.5915V13.4223C17.375 13.9513 16.9666 14.3801 16.4628 14.3801H5.51757C5.01383 14.3801 4.60547 13.9513 4.60547 13.4223V9.5915ZM6.42968 10.5492V12.4646H15.5507V10.5492H6.42968Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_14228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8905,
    height: 22.9851,
    fill: "white",
    transform: "translate(0.0449219 0.0146484)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadClosure);
export default __webpack_public_path__ + "static/media/road_closure.d99628d7064805aed25aa05e61561dd1.svg";
export { ForwardRef as ReactComponent };